import { useId, useState } from 'react'

import { t } from '../strings'

interface Props {
  label: string
  value: string
  onChange: (value: string) => void
  autoComplete: 'current-password' | 'new-password'
  minLength?: number
  /** Shown under the field, e.g. "passwords don't match". */
  error?: string | null
}

/** A password input with a "Tampilkan / Sembunyikan" toggle, as owners expect from common sign-up forms. */
export function PasswordField({ label, value, onChange, autoComplete, minLength, error }: Props) {
  const [visible, setVisible] = useState(false)
  const id = useId()
  const errorId = `${id}-error`
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="password-row">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          minLength={minLength}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          required
        />
        <button
          type="button"
          className="toggle"
          aria-controls={id}
          aria-pressed={visible}
          aria-label={visible ? `${t.hidePassword} ${label.toLowerCase()}` : `${t.showPassword} ${label.toLowerCase()}`}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? t.hidePassword : t.showPassword}
        </button>
      </div>
      {error && (
        <p id={errorId} className="field-error">
          {error}
        </p>
      )}
    </div>
  )
}
